import { useEffect } from 'react';
import { XLg } from 'react-bootstrap-icons';

import { Typography, notification } from 'antd';

import maintenanceService from '@/services/maintenance';

const MaintenanceMessage = () => {
  useEffect(() => {
    maintenanceService.getMaintenanceMessage().then(({ message }) => {
      if (message) {
        notification.open({
          type: 'warning',
          message: <Typography.Text>{message}</Typography.Text>,
          placement: 'top',
          duration: 0,
          closeIcon: <XLg color='#000' style={{ alignSelf: 'flex-start' }} />,
          style: { width: '90vw', paddingBottom: 2, paddingTop: 12, backgroundColor: '#fef9eb' }
        });
      }
    });
  }, []);
  return <></>;
};

export default MaintenanceMessage;
